module.exports = __webpack_public_path__ + "static/media/logo72x72.5a21c54a.png";